import BaseAPI from '@/apis/base/baseApi';

export default class SFApi extends BaseAPI {
  apiName = 'SF';
}
